export const isNumber = (obj: unknown) => {
  return typeof obj === "number";
};
